import React, { useEffect } from "react";
import useForm from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";
import { Login } from "../../actions/authActions";
import { EMAIL_REGEX } from "../../constants";

const LoginForm = () => {
  const { register, handleSubmit, errors, setValue, formState } = useForm();
  const history = useHistory();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => !!state.auth.isAuthenticated);
  useEffect(() => {
    register(
      { name: "email" },

      {
        required: "Please enter your email",
        pattern: { value: EMAIL_REGEX, message: "Please enter correct email" },
      }
    );
    register({ name: "password" }, { required: "Please enter your password" });
  }, [register]);
  useEffect(() => {
    if (isAuthenticated) {
      history.push("/");
    }
  }, [isAuthenticated, history]);
  const onSubmit = (data) => {
    dispatch(Login(data.email, data.password));
    history.push("/");
  };

  return (
    <Grid textAlign="center" style={{ height: "80vh" }} verticalAlign="middle">
      <Grid.Column style={{ maxWidth: 450 }}>
        <Header as="h2" color="teal" textAlign="center">
          Log-in to your account
        </Header>
        <Form size="large" onSubmit={handleSubmit(onSubmit)}>
          <Segment stacked textAlign="left">
            <Form.Input
              fluid
              icon="user"
              name="email"
              iconPosition="left"
              placeholder="E-mail address"
              onChange={(e) =>
                setValue("email", e.target.value, formState.isSubmitted)
              }
              error={errors.email ? errors.email.message : null}
            />
            <Form.Input
              fluid
              icon="lock"
              name="password"
              iconPosition="left"
              placeholder="Password"
              type="password"
              onChange={(e) =>
                setValue("password", e.target.value, formState.isSubmitted)
              }
              error={errors.password ? errors.password.message : null}
            />
            <Button color="teal" fluid size="large">
              Login
            </Button>
          </Segment>
        </Form>
      </Grid.Column>
    </Grid>
  );
};

export default LoginForm;
